import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-global-overview-management',
  templateUrl: './global-overview-management.component.html',
  styleUrls: ['./global-overview-management.component.css']
})
export class GlobalOverviewManagementComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
